import Icon from 'veui/components/Icon'
import { IconTag } from 'dls-icons-vue'

Icon.register('tag', IconTag)
